module.exports = __webpack_public_path__ + "media/images/ic_settings-e958d028be02ee650cdc8fcd41466de2.svg";